module.exports = __webpack_public_path__ + "img/robotics-col.jpg";